import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ProductPicker } from './ProductPicker';

export const ProductPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'ProductPicker',
        // @ts-ignore
        component: ProductPicker,
    }),
);
